:host {
  display: block;
  width: 100%;
  height: 100%;
}

:host,
.empty-state,
.empty-state__text {
  box-sizing: border-box;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--dimension-space-100);
  height: 100%;
  width: 100%;
  text-align: center;
}

.empty-state__icon {
  flex: 0 0 auto;
}

.empty-state__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--dimension-space-050);
  width: 100%;
}
